import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TitleWithStar from "../../../Shared/TitleWithStar";
import Image from "react-bootstrap/Image";
import IconSvg from "../../../../SharedComponents/IconSvg";
import { Button, Form } from "react-bootstrap";
import React, { useState } from "react";
import { landingPageReactSelectStyles } from "../../../../SharedComponents/reactSelectStyles";
import Select from "react-select";
import { createConnectionRequest } from "../../../Store/Thunk";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const ContactUsSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const reactSelectOptions = [
    { value: "cusPro", label: "cus-pro" },
    {
      value: "mentorship",
      label: t("landing.home.contactUs.careerConsulting"),
    },
  ];

  const [nameSurname, setNameSurname] = useState("");
  const [email, setEmail] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submitForm = () => {
    const subject =
      selectedProduct.map((option) => option.value).join(", ") + " - " + t("landing.home.contactUs.subjectSuffix");

    const payload = {
      Name: nameSurname,
      Email: email,
      Subject: subject,
    };

    dispatch(createConnectionRequest(payload)).then(() => {
      resetForm(); // clears the form after dispatch
    });
  };

  const resetForm = () => {
    setNameSurname("");
    setEmail("");
    setSelectedProduct(null);
  };

  return (
    <Row className={"justify-content-center mx-lg-0 mt-4"}>
      <Col xs={12} xl={11} style={{ backgroundColor: "#274C77", borderRadius: "30px", minHeight: "500px" }}>
        <Row className={"justify-content-between mx-0 h-100"}>
          <Col xs={12} lg={7} className="d-flex flex-column justify-content-between">
            <Row className={"ms-lg-2"}>
              <Col xs={"auto"}>
                <TitleWithStar
                  text={t("landing.home.contactUs.title")}
                  color={"#fff"}
                  className={"mt-5 "}
                ></TitleWithStar>
              </Col>
            </Row>
            <Row
              className={"EB-Garamond text-48 text-lg-56 fw-medium text-color-white ms-lg-2 lh-1 mt-4 mb-5"}
              style={{ letterSpacing: "-1px" }}
            >
              <Col>{t("landing.home.contactUs.subtitle")}</Col>
            </Row>

            <Form onSubmit={submitForm}>
              <Row className={"ms-lg-2 my-4"}>
                <Col xs={12} lg={10}>
                  <Form.Control
                    placeholder={t("landing.home.contactUs.namePlaceholder")}
                    className={"landing-page-input"}
                    value={nameSurname}
                    onChange={(e) => setNameSurname(e.target.value)}
                  ></Form.Control>
                </Col>
              </Row>
              <Row className={"ms-lg-2 my-4"}>
                <Col xs={12} lg={10}>
                  <Form.Control
                    placeholder={t("landing.home.contactUs.emailPlaceholder")}
                    className={"landing-page-input"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  ></Form.Control>
                </Col>
              </Row>
              <Row className={"ms-lg-2 my-4"}>
                <Col xs={12} lg={10}>
                  <Select
                    isMulti
                    placeholder={t("landing.home.contactUs.productPlaceholder")}
                    styles={landingPageReactSelectStyles}
                    options={reactSelectOptions}
                    value={selectedProduct}
                    onChange={(selected) => {
                      setSelectedProduct(selected);
                    }}
                  />
                </Col>
              </Row>
            </Form>
            <Row className={"ms-lg-2 mt-auto mb-5"}>
              <Col xs={"auto"}>
                <Button
                  onClick={() => submitForm()}
                  className={"button white rounded-pill px-2"}
                  disabled={!isEmailValid}
                  style={{ opacity: (!email || isEmailValid) && 1 }}
                >
                  <Row>
                    <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.home.contactUs.sendButton")}</Col>
                    <Col xs={"auto"}>
                      <div
                        className={"rounded-circle flex-center"}
                        style={{ backgroundColor: "#274c77", width: 36, height: 36 }}
                      >
                        <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} fill={"#fff"} />
                      </div>
                    </Col>
                  </Row>
                </Button>
              </Col>
            </Row>
          </Col>
          <Col xs={12} lg={5} className={"align-content-center py-3 px-1"}>
            <Image
              src={"/LandingPageImages/businessManAndWoman.webp"}
              width="100%"
              style={{ minWidth: 200 }}
              alt={"business man and woman"}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default ContactUsSection;
